import styled from 'styled-components';

interface ContainerProps {
	styles?: React.CSSProperties;

	$styles1200px?: React.CSSProperties;

	$styles992px?: React.CSSProperties;

	$styles768px?: React.CSSProperties;

	$styles576px?: React.CSSProperties;
}

export const Container = styled.div<ContainerProps>`
	@media (min-width: 576px) {
		display: ${props => props.$styles576px?.display};
		margin: ${props => props.$styles576px?.margin};
		margin-top: ${props => props.$styles576px?.marginTop};
		margin-right: ${props => props.$styles576px?.marginRight};
		margin-bottom: ${props => props.$styles576px?.marginBottom};
		margin-left: ${props => props.$styles576px?.marginLeft};
		padding: ${props => props.$styles576px?.padding};
		padding-top: ${props => props.$styles576px?.paddingTop};
		padding-right: ${props => props.$styles576px?.paddingRight};
		padding-bottom: ${props => props.$styles576px?.paddingBottom};
		padding-left: ${props => props.$styles576px?.paddingLeft};
		top: ${props => props.$styles576px?.top};
		left: ${props => props.$styles576px?.left};
		right: ${props => props.$styles576px?.right};
		bottom: ${props => props.$styles576px?.bottom};
		width: ${props => props.$styles576px?.width};
		max-width: ${props => props.$styles576px?.maxWidth};
	}
	@media (min-width: 768px) {
		display: ${props => props.$styles768px?.display};
		margin: ${props => props.$styles768px?.margin};
		margin-top: ${props => props.$styles768px?.marginTop};
		margin-right: ${props => props.$styles768px?.marginRight};
		margin-bottom: ${props => props.$styles768px?.marginBottom};
		margin-left: ${props => props.$styles768px?.marginLeft};
		padding: ${props => props.$styles768px?.padding};
		padding-top: ${props => props.$styles768px?.paddingTop};
		padding-right: ${props => props.$styles768px?.paddingRight};
		padding-bottom: ${props => props.$styles768px?.paddingBottom};
		padding-left: ${props => props.$styles768px?.paddingLeft};
		top: ${props => props.$styles768px?.top};
		left: ${props => props.$styles768px?.left};
		right: ${props => props.$styles768px?.right};
		bottom: ${props => props.$styles768px?.bottom};
		width: ${props => props.$styles768px?.width};
		max-width: ${props => props.$styles768px?.maxWidth};
	}
	@media (min-width: 992px) {
		display: ${props => props.$styles992px?.display};
		margin: ${props => props.$styles992px?.margin};
		margin-top: ${props => props.$styles992px?.marginTop};
		margin-right: ${props => props.$styles992px?.marginRight};
		margin-bottom: ${props => props.$styles992px?.marginBottom};
		margin-left: ${props => props.$styles992px?.marginLeft};
		padding: ${props => props.$styles992px?.padding};
		padding-top: ${props => props.$styles992px?.paddingTop};
		padding-right: ${props => props.$styles992px?.paddingRight};
		padding-bottom: ${props => props.$styles992px?.paddingBottom};
		padding-left: ${props => props.$styles992px?.paddingLeft};
		top: ${props => props.$styles992px?.top};
		left: ${props => props.$styles992px?.left};
		right: ${props => props.$styles992px?.right};
		bottom: ${props => props.$styles992px?.bottom};
		width: ${props => props.$styles992px?.width};
		max-width: ${props => props.$styles992px?.maxWidth};
	}
	@media (min-width: 1200px) {
		display: ${props => props.$styles1200px?.display};
		margin: ${props => props.$styles1200px?.margin};
		margin-top: ${props => props.$styles1200px?.marginTop};
		margin-right: ${props => props.$styles1200px?.marginRight};
		margin-bottom: ${props => props.$styles1200px?.marginBottom};
		margin-left: ${props => props.$styles1200px?.marginLeft};
		padding: ${props => props.$styles1200px?.padding};
		padding-top: ${props => props.$styles1200px?.paddingTop};
		padding-right: ${props => props.$styles1200px?.paddingRight};
		padding-bottom: ${props => props.$styles1200px?.paddingBottom};
		padding-left: ${props => props.$styles1200px?.paddingLeft};
		top: ${props => props.$styles1200px?.top};
		left: ${props => props.$styles1200px?.left};
		right: ${props => props.$styles992px?.right};
		bottom: ${props => props.$styles1200px?.bottom};
		width: ${props => props.$styles1200px?.width};
		max-width: ${props => props.$styles1200px?.maxWidth};
	}
	display: ${props => props.styles?.display};
	transition: ${props => props.styles?.transition};
	top: ${props => props.styles?.top};
	left: ${props => props.styles?.left};
	right: ${props => props.styles?.right};
	bottom: ${props => props.styles?.bottom};
	overflow: ${props => props.styles?.overflow};
	border: ${props => props.styles?.border};
	position: ${props => props.styles?.position};
	opacity: ${props => props.styles?.opacity};
	flex-direction: ${props => props.styles?.flexDirection};
	flex-wrap: ${props => props.styles?.flexWrap};
	width: ${props => props.styles?.width};
	height: ${props => props.styles?.height};
	justify-content: ${props => props.styles?.justifyContent};
	align-items: ${props => props.styles?.alignItems};
	column-gap: ${props => props.styles?.columnGap};
	row-gap: ${props => props.styles?.rowGap};
	place-content: ${props => props.styles?.placeContent};
	margin: ${props => props.styles?.margin};
	margin-top: ${props => props.styles?.marginTop};
	margin-right: ${props => props.styles?.marginRight};
	margin-bottom: ${props => props.styles?.marginBottom};
	margin-left: ${props => props.styles?.marginLeft};
	padding: ${props => props.styles?.padding};
	padding-top: ${props => props.styles?.paddingTop};
	padding-right: ${props => props.styles?.paddingRight};
	padding-bottom: ${props => props.styles?.paddingBottom};
	padding-left: ${props => props.styles?.paddingLeft};
	background-color: ${props => props.styles?.backgroundColor};
	z-index: ${props => props.styles?.zIndex};
	background-image: ${props => props.styles?.backgroundImage};
	text-align: ${props => props.styles?.textAlign};
	border-top: ${props => props.styles?.borderTop};
	max-width: ${props => props.styles?.maxWidth};
`;
